import { render, staticRenderFns } from "./NINProviderChart.vue?vue&type=template&id=4652f708&"
import script from "./NINProviderChart.vue?vue&type=script&lang=js&"
export * from "./NINProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports